// extracted by mini-css-extract-plugin
export default {"tooltipWrapper":"TooltipWrapper_tooltipWrapper__Xqf44"};